export const setCatalogHeight = () => {
	const catalog = document.querySelector('.catalog.js-nav-drawer');
	if (!catalog) return;

	const list = catalog.querySelector('.catalog__list');
	const sublists = catalog.querySelectorAll('.catalog__sublist');
	let height = list.offsetHeight;

	sublists.forEach((sublist) => {
		const sublistHeight = sublist.offsetHeight;
		height = sublistHeight > height ? sublistHeight : height;
	});
	catalog.style.setProperty('--catalog-height', `${height}px`);
};

export const setCatalogDropdownLinks = () => {
	const catalog = document.querySelector('.catalog.js-nav-drawer');
	if (!catalog) return;

	const laptopMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);
	const hoverSupport =
		window.matchMedia('(any-hover: hover)').matches ||
		!('ontouchstart' in window || navigator.maxTouchPoints > 0);

	const links = catalog.querySelectorAll('.catalog__link.js-dropdown__button');
	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			if (!laptopMQ.matches || hoverSupport) return;
			if (!link.closest('.catalog__list > .catalog__item').querySelector('.is-open')) {
				links.forEach((otherLink) => {
					otherLink.classList.remove('is-open');
				});
			}
			if (link.classList.contains('is-open')) return;
			e.preventDefault();
			link.classList.add('is-open');
		});
	});

	catalog.addEventListener('navDrawerClose', () => {
		links.forEach((link) => {
			link.classList.remove('is-open');
		});
	});
};
